module.exports = "<div class=banque-option> <div class=icon-col> <div class=icon-wrap ng-if=\"::option.id != null && !option.$notBank\"> <logo-contrepartie size=icon contrepartie-id={{::option.id}} contrepartie-type=BANQUE></logo-contrepartie> </div> </div> <div class=label-col> <span class=label>{{::option.libelleCourtUsuel}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/banques/banqueOption.html
// module id = 947
// module chunks = 13